import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=70e14392&scoped=true&"
import script from "./GroupsTable.vue?vue&type=script&lang=js&"
export * from "./GroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTable.vue?vue&type=style&index=0&id=70e14392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e14392",
  null
  
)

export default component.exports